import { Injectable } from '@angular/core';
import { Order } from '../../models/intefaces/order';
import { Control } from '../../models/controls/control';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  private readonly values = new Map<string, Control<any>>();

  constructor() {}

  load(controls: Control<any>[][]): void {
    controls.forEach((form) => form.forEach((control) => this.setup(control)));
  }

  private setup(control: Control<any>): void {
    this.values.set(control.name, control);
    const value = sessionStorage.getItem(control.name);
    if (value) {
      control.value = value;
    }
  }

  store(control: Control<any>): void {
    if (this.values.has(control.name)) {
      sessionStorage.setItem(control.name, control.value);
    }
  }

  clear(control: Control<any>): void {
    if (this.values.has(control.name)) {
      sessionStorage.removeItem(control.name);
    }
  }

  isControlValid(control: Control<any>): boolean {
    const value = sessionStorage.getItem(control.name);
    return !control.required || value === control.value;
  }

  getValue(name: string): string {
    const control = this.values.get(name);
    return control?.value || '';
  }

  export(): Order {
    const order: any = {};
    this.values.forEach((control, name) => (order[name] = control.value));
    return order as Order;
  }

  reset(): void {
    this.values.forEach((control: Control<any>) => {
      sessionStorage.removeItem(control.name);
      delete control.value;
    });
  }
}
